module.exports = __webpack_public_path__ + "static/media/BD_02.b94f18b9.png";